import { create } from "zustand";

interface IProcessMonitorStore {
    activeCount: number;
    setActiveCount: (count: number) => void;
}

export const useProcessMonitorStore = create<IProcessMonitorStore>((set) => ({
    activeCount: 0,
    setActiveCount: (count: number) => set({ activeCount: count }),
}));
